var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lex-container"},[_c('div',{staticClass:"plain-html-module",domProps:{"innerHTML":_vm._s(_vm.TextData)}})])}
var staticRenderFns = []

export { render, staticRenderFns }